module.exports = __webpack_public_path__ + "public/files/img/report.4273edab.png";